import React, {useEffect, useRef, useState} from 'react';
import {PageLayout} from '@Local/Components/Layout';
import {Grid} from '@mui/material';
import OrderCustomerInfoSection from '@Local/Orders/OrderViewPage/OrderCustomerInfoSection';
import OrderPaymentInfoSection from '@Local/Orders/OrderViewPage/OrderPaymentInfoSection';
import OrderItemsSection from '@Local/Orders/OrderViewPage/OrderItemsSection';
import OrderRecordsSection from '@Local/Orders/OrderViewPage/OrderRecordsSection';
import useOrderApi from '@Apis/useOrderApi';
import {useParams} from 'react-router-dom';
import {isEmpty} from '@Util/utils';
import OrderActionMenu from '@Local/Orders/OrderViewPage/Components/OrderActionMenu';
import OrdersDialogBox from '@Local/Orders/Componetnets/OrdersDialogBox';
import FinanceDialogBox from '@Local/Finance/Components/FinanceDialogBox';
import { Box, Chip, Divider, Stack, Typography } from '@curves/ui-base';

import {DATE_TIME_STANDARD, ORDER_STATUS_COLOR_MATCH} from '@Constants/appConfig';
import {parseDate} from '@Util/moment.util';
import OrderClubInfoSection from '@Local/Orders/OrderViewPage/OrderClubInfoSection';
import OrderInvoiceInfoSection from '@Local/Orders/OrderViewPage/OrderInvoiceInfoSection';
/**
 * 訂單檢視頁面
 *
 * 功能：
 * - 顯示訂單的完整詳細資訊
 * - 包含客戶資訊、付款資訊、商品清單等
 * - 提供訂單操作功能
 *
 * @component
 * @returns {JSX.Element} 訂單檢視頁面
 */
const OrderViewPage = () => {
    const { getOrderApi } = useOrderApi();
    const {orderID} = useParams();
    const dialogRef = useRef(null);
    const financeDialogRef = useRef(null);
    const [orderData, setOrderData] = useState({});
    const orderNoInfo = orderData?.info?.orderNo ? ` #${orderData.info.orderNo}` : '';
    /**
     * 取得訂單資料
     * @param {string|number} orderId - 訂單 ID
     */
    const fetchOrderData = async (orderId) => {
        const resp = await getOrderApi(orderId);
        if (resp) {
            setOrderData(resp);
        }
    }
    /**
     * 處理刷新操作
     */
    const handleRefresh = () => {
        if (!orderID) return;
        fetchOrderData(orderID);
    }
    useEffect(() => {
        if (!orderID) return;
        fetchOrderData(orderID);
    },
        // eslint-disable-next-line
        [orderID])
    return (
        <PageLayout className={'order-view-page'} title={`訂單詳情${orderNoInfo}`}>
            {
                isEmpty(orderData) ? null : (
                <>
                    <Stack justifyContent={'space-between'} alignItems={'start'} spacing={2}>
                        <Box>
                            <Stack justifyContent={'start'} alignItems={'center'} spacing={1}>
                                <Typography className={'page-header-title'} variant={'h4'}>
                                    訂單：{orderData?.info?.orderNo}
                                </Typography>
                                <Chip label={orderData?.info?.orderStatusText}
                                      color={ORDER_STATUS_COLOR_MATCH[orderData?.info?.orderStatusColor || 0]}/>
                            </Stack>
                            <Typography className={'font-color-3'} variant="body2">建立時間：{parseDate(orderData?.info?.orderDate, DATE_TIME_STANDARD.DISPLAYFULLBYSLASH)}</Typography>
                        </Box>
                        <OrderActionMenu sourceData={orderData} dialogRef={dialogRef} refresh={handleRefresh} />
                    </Stack>
                    <Divider className={'mt-1 mb-3'}/>
                    <Grid container spacing={2}>
                        <Grid xs={12} md={7} item>
                            <OrderCustomerInfoSection className={'mb-2'} infoData={orderData?.info} paymentData={orderData?.payment} />
                            <OrderClubInfoSection className={'mb-2'} infoData={orderData?.info} />
                            <OrderItemsSection className={'mb-2'} paymentData={orderData?.payment} items={orderData?.items} orderType={orderData?.orderType}  />
                            <OrderPaymentInfoSection paymentData={orderData?.payment} />
                        </Grid>
                        <Grid xs={12} md={5} item>
                            <OrderInvoiceInfoSection
                                className={'mb-2'}
                                paymentData={orderData?.payment}
                                allowances={orderData?.allowances}
                                dialogRef={dialogRef}
                                financeDialogRef={financeDialogRef}
                                isUploadedCertificate={orderData?.isUploadedCertificate}
                                confirmPath={orderData?.confirmPath}
                                orderID={orderData?.info?.orderID}
                                orderReturnID={orderData?.orderReturnID}
                                refresh={handleRefresh}
                            />
                            <OrderRecordsSection sourceData={orderData?.records} />
                        </Grid>
                    </Grid>
                </>
                )
            }
            <OrdersDialogBox ref={dialogRef} />
            <FinanceDialogBox ref={financeDialogRef} />
        </PageLayout>
    )
};
export default OrderViewPage;
